import {
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core"
import { corDoStatus, formatarMoeda } from "./constants"

const Linha = ({ rotulo, valor }) =>
    valor ? (
        <Box>
            <Typography variant="caption" color="textSecondary">
                {rotulo}
            </Typography>
            <Typography variant="body2">{valor}</Typography>
        </Box>
    ) : null

export default function DialogDetalhesPedido({ open, onClose, pedido }) {
    if (!pedido) return null

    const endereco = pedido.deliveryAddress
    const enderecoTexto = endereco
        ? [endereco.street, endereco.neighborhood, endereco.city].filter(Boolean).join(" - ")
        : ""

    const pagamento = pedido.payments
    const pagamentoTexto = Array.isArray(pagamento)
        ? pagamento.map(p => p.name).join(", ")
        : pagamento?.name

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Pedido #{pedido.id}{" "}
                <Chip
                    label={pedido.descricaoStatus || "—"}
                    size="small"
                    style={{
                        backgroundColor: corDoStatus(pedido.descricaoStatus),
                        color: "white",
                        marginLeft: 8,
                    }}
                />
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Linha rotulo="Data/Hora" valor={pedido.dateFormatted} />
                    </Grid>
                    <Grid item xs={6}>
                        <Linha rotulo="Tipo" valor={pedido.type} />
                    </Grid>
                    <Grid item xs={6}>
                        <Linha rotulo="Plataforma" valor={pedido.plataforma} />
                    </Grid>
                    <Grid item xs={6}>
                        <Linha rotulo="Forma de pagamento" valor={pagamentoTexto} />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2">Cliente</Typography>
                        <Linha rotulo="Nome" valor={pedido.customer?.name} />
                        <Linha rotulo="Telefone" valor={pedido.customer?.phone} />
                        <Linha rotulo="E-mail" valor={pedido.customer?.email} />
                    </Grid>
                    {enderecoTexto && (
                        <Grid item xs={12}>
                            <Linha rotulo="Endereço de entrega" valor={enderecoTexto} />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" gutterBottom>
                            Itens
                        </Typography>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Item</TableCell>
                                    <TableCell align="right">Qtd</TableCell>
                                    <TableCell align="right">Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(pedido.items || []).map((item, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell align="right">{item.quantity}</TableCell>
                                        <TableCell align="right">
                                            {formatarMoeda(item.totalPrice)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {(!pedido.items || pedido.items.length === 0) && (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            Sem itens
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={6}>
                        <Linha rotulo="Subtotal" valor={formatarMoeda(pedido.subTotal)} />
                    </Grid>
                    <Grid item xs={6}>
                        <Linha
                            rotulo="Taxa de entrega"
                            valor={formatarMoeda(pedido.deliveryFee)}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Linha rotulo="Desconto" valor={formatarMoeda(pedido.discountTotal)} />
                    </Grid>
                    <Grid item xs={6}>
                        <Box>
                            <Typography variant="caption" color="textSecondary">
                                Total
                            </Typography>
                            <Typography variant="h6">
                                {formatarMoeda(pedido.totalPrice)}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}
